export const Props = () => ({
  //--------------------------------------------------------------------------
  //                      Статичное значение кол-ва комментариев
  //--------------------------------------------------------------------------
  count: {
    type: Number,
    default: 0,
  },
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

   //--------------------------------------------------------------------------
  //                      Актуальное значение кол-ва комментариев
  //--------------------------------------------------------------------------
  newCommentsCounter: {
    type: [Number, null],
    default: 0,
  },
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

  //----------------------------------------------------------------------------
  //                               Кликабелен ли объект
  //----------------------------------------------------------------------------
  isClickable:{
    type: Boolean,
    default: false,
  },
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

  //----------------------------------------------------------------------------
  //                              Внешний вид счетчика
  //----------------------------------------------------------------------------
  type: {
    type: String,
    default: 'default',
    validator: (value) => {
      const allowedTypes = ['default', 'light'];
      if(allowedTypes.includes(value)){
        return true;
      } else{
        throw new Error(`Параметр 'type' в компоненте CounterComment может содержать только значения: ${allowedTypes.join(', ')}`);
      }
    }
  },
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
});